import PropTypes from 'prop-types';
import classNames from 'classnames';
import withErrorBoundary from './withErrorBoundary/index';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  shouldColor: PropTypes.bool,
  color: PropTypes.string,
  shouldAvoidDecimals: PropTypes.bool,
  isAttachCurrency: PropTypes.bool,
  isAddPercentage: PropTypes.bool,
  showCurrencyCode: PropTypes.bool,
  isCrypto: PropTypes.bool,
  className: PropTypes.string,
};

const defaultProps = {
  children: null,
  shouldColor: false,
  color: '',
  shouldAvoidDecimals: false,
  isAttachCurrency: true,
  isAddPercentage: false,
  showCurrencyCode: false,
  className: '',
};

const getFormattedMoney = (money, shouldAvoidDecimals) => {
  if (money === null || money === undefined || money === '') return 0;

  const value = Number(money);
  if (Number.isNaN(value)) return 0;

  return shouldAvoidDecimals ? Math.trunc(value) : value;
};

const Money = ({
  children,
  shouldColor,
  color,
  shouldAvoidDecimals,
  isAttachCurrency,
  isAddPercentage,
  showCurrencyCode,
  isCrypto = ApplicationDomainUtility.isCrypto,
  className = ''
}) => {
  const intlFormatter = isCrypto
    ? new Intl.NumberFormat('en-US')
    : new Intl.NumberFormat('en-IN');

  const money = getFormattedMoney(children, shouldAvoidDecimals);

  const moneyStyle = classNames('default d-flex align-items-center money-span', className , {
    'text-success': shouldColor && children > 0,
    'text-danger': (shouldColor && (color === 'red' || children <= 0)),
  });

  // Currency icon classes (FIXED — no quotes)
  const currencyIconClass = isCrypto
    ? 'fa-regular font-size-inherit align-bottom currency-icon fs-6 ms-1 me-1'
    : 'fa-regular fa-indian-rupee-sign font-size-inherit align-bottom currency-icon fs-6 ms-1 me-1';

  return (
    <span className={moneyStyle}>
      {children < 0 && '-'}
      {isAttachCurrency && <i className={currencyIconClass} />}
      <span>{intlFormatter.format(Math.abs(money))}</span>
      {isAddPercentage && '%'}
      {showCurrencyCode && isCrypto && (
        <span className="ms-1 font-size-90">USD</span>
      )}
    </span>
  );
};

Money.propTypes = propTypes;
Money.defaultProps = defaultProps;

export default withErrorBoundary(Money, 'Errored', false);
